import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DataCollection } from '../models/models';
//import {
//    ApplicationControl
//    , APIResponse
//} from '../models/models';

//const httpOptions = {
//    headers: new HttpHeaders({
//        'Content-Type': 'application/json'
//    })
//};

@Injectable()
export class DataService {
    public dataCollection: DataCollection = {} as DataCollection;
    public dataCollectionList: DataCollection[] = [];
    public subject = new Subject<DataCollection>();
    private dataSource: BehaviorSubject<DataCollection> = new BehaviorSubject(this.dataCollection);
    public currentDataCollection: Observable<DataCollection> = this.dataSource.asObservable();

    constructor() {
    }

    public set(col: DataCollection) {
        console.log("dataService.set", col);
        this.clear(col.name);
        this.dataSource.next(col);
        this.add(col);
    }

    public get(name: string) {
        var dataCol = this.dataCollectionList.find(d => d.name == name);
        return dataCol;
    }

    public clear(name: string) {
        var dataColList = this.dataCollectionList.filter(d => d.name != name);
        this.dataCollectionList.length = 0;
        this.dataCollectionList = dataColList;
    }

    private add(col: DataCollection) {
        this.dataCollectionList.push(col);
    }
}